import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useDemandForm = (onSubmit, values, readOnly) => {
  const fields = useMemo(
    () => [
      {
        title: 'Demand',
        fields: [
          {
            title: 'Date Effective',
            name: 'date_effective',
            type: 'date',
            required: true,
            disablePastDates: true,
            readOnly,
          },
          {
            title: 'Status',
            name: 'status',
            type: 'select',
            isHidden: () => !values?.id,
            readOnly,
            options: [
              { value: 'pending', label: 'Pending' },
              { value: 'active', label: 'Active' },
              { value: 'cancelled', label: 'Cancelled' },
              { value: 'satisfied', label: 'Satisfied' },
            ],
          },
          {
            title: 'Amount',
            name: 'amount',
            type: 'currency',
            readOnly: true,
            isHidden: () => !values?.id,
          },
          {
            title: 'Acceleration date',
            name: 'acceleration_date',
            type: 'date',
            isHidden: () => !values?.id,
            readOnly,
          },
          {
            title: 'Acceleration reviewed',
            name: 'acceleration_attorney_reviewed',
            type: readOnly ? 'text' : 'checkbox',
            readOnly,
            isHidden: () => !values?.id,
            format: (value) => {
              if (!readOnly) {
                return value;
              }
              return value === 'true' ? 'Yes' : 'No';
            },
          },
          {
            title: 'Sale date',
            name: 'sale_date',
            type: 'date',
            readOnly,
            isHidden: () => !values?.id,
          },
        ],
      },
    ],
    [readOnly, values?.id]
  );

  return useForm({ fields, onSubmit, values });
};

export default useDemandForm;
